import { getMasterData } from 'master-data'
import { Domains } from 'monitoring/constants/domains'
import { sendError } from 'monitoring/sendError/server/sendError'
import { sendLog } from 'monitoring/sendLog/server/sendLog'
import { getServerProductPriceUrl } from 'product/services/productPrices/getServerProductPriceUrl'
import { type ProductPrices } from 'product/types/Prices'
import { getHeaderAkamai } from 'utils/akamai'
import { getAkamaiFF } from 'utils/akamai/getAkamaiFF'

export const getAllPrices = async (
	product: string
): Promise<Record<string, ProductPrices> | undefined> => {
	try {
		const masterdata = getMasterData()
		const { orchestrator: orchestratorFromAkamai } = getAkamaiFF()

		const {
			country: { countryISO },
			channel,
		} = masterdata

		const pricesUrl = getServerProductPriceUrl({
			productId: product,
			countryISO,
			channel,
		})

		let headers = {}
		if (orchestratorFromAkamai) {
			headers = await getHeaderAkamai()
		}
		const pricesResponse = await fetch(pricesUrl, {
			headers,
			next: { revalidate: 0 },
		})

		return pricesResponse.json()
	} catch (e) {
		sendLog({
			domain: Domains.Product,
			message: '[Prices] get all prices',
			custom: {
				error: e,
			},
		})

		return undefined
	}
}

export const getPrices = async (
	product: string,
	color: string
): Promise<ProductPrices | undefined> => {
	if (!product || !color) {
		throw sendError({
			domain: Domains.Product,
			message: '[Prices] Product and color are required',
			custom: {
				color,
				productId: product,
			},
		})
	}

	const pricesFetched = await getAllPrices(product)

	if (!pricesFetched?.[color]) {
		throw sendError({
			domain: Domains.Product,
			message: '[Prices] This color has no prices',
			custom: {
				color,
				productId: product,
			},
		})
	}

	return pricesFetched[color]
}
